import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Loader from '@/components/Loader/Loader'
import ArticleImage from './Sections/ArticleImage'
import './style.scss'

export default function ArticlePage() {
  const { slug } = useParams()
  const [article, setArticle] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    setError(null)

    axios
      .get(`${import.meta.env.VITE_API_URL}/v1/article/${slug}`)
      .then((res) => {
        setArticle(res.data)
      })
      .catch((err) => {
        setError(err.response?.data?.message ?? 'Wystąpił błąd.')
      })
      .finally(() => setLoading(false))
  }, [slug])

  if (error) {
    return (
      <div className="alert alert-danger my-3" role="alert">
        {error}
      </div>
    )
  }

  return (
    <div className="post">
      {loading ? (
        <Loader size="5" />
      ) : (
        <>
          <ArticleImage {...article} />
          <div
            className="post__content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />
        </>
      )}
    </div>
  )
}